import React, { useState, useRef, useEffect } from 'react';
import { Button, Image } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { CSVReader } from 'react-papaparse';
import { connect } from 'react-redux';

import { CustomTitleLabel } from './CustomBaseComponments';
import { ReactHookFormErrorMessage } from '../base/ErrorFieldMessage';
import { removeElementFromArray } from '../../utils';

import deleteImage from '../../assets/images/earning/deletex1.png';

import '../campaign/campaignCreation/PropertiesGeneralSection.scss';
import './RewardSection.scss';
import './QRCodeScanningSection.scss';

const mapPropsToState = (state) => ({})
function QRCodeScanningSection({
  qrCodeFieldName = "qrCodes",
}) {
  const { watch, formState, setValue } = useFormContext();
  const buttonRef = useRef();
  const errors = formState.errors;
  const camma = ',';

  const [showFileBox, setShowFileBox] = useState(false);
  const qrCodes = watch(qrCodeFieldName) || []
  
  const [inputQRCodes, setInputQRCodes] = useState(qrCodes || [])
  const [importQRCodes, setImportQRCodes] = useState([])

  const handleOpenDialog = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  const handleOnFileLoad = (data) => {
    console.log('---------------------------');
    console.log(data);
    console.log('---------------------------');

    let currentImportedQRCodes = [];
    data.map((element) => {
      const hasValueData = removeElementFromArray(element.data, '');
      if (hasValueData.length > 0) {
        currentImportedQRCodes = [...currentImportedQRCodes, ...hasValueData];
      }
      return undefined
    });
    setImportQRCodes(currentImportedQRCodes)

    setShowFileBox(true);
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  const handleOnRemoveFile = (data) => {
    console.log('---------------------------');
    console.log(data);
    console.log('---------------------------');
  };

  const handleRemoveFile = (e) => {
    // Note that the ref is set async, so it might be null at some point
    if (buttonRef.current) {
      buttonRef.current.removeFile(e);
      setImportQRCodes([])
      setShowFileBox(false);
    }
  };

  const setQRCodesWithoutDuplicate = (inputQRCodes, importQRCodes) => {
    const nonEmptyInputQRcodes = removeElementFromArray(inputQRCodes, '');
    const nonEmptyImportQRcodes = removeElementFromArray(importQRCodes, '');

    const importRemoveDuplicateFromInput = nonEmptyImportQRcodes?.filter(
      (val) => !nonEmptyInputQRcodes.includes(val),
    ) || [];

    console.log("@181", importRemoveDuplicateFromInput, nonEmptyInputQRcodes)
    setValue(qrCodeFieldName, [...importRemoveDuplicateFromInput, ...nonEmptyInputQRcodes], {shouldDirty: true})
  };

  useEffect(()=>{
    setQRCodesWithoutDuplicate(inputQRCodes, importQRCodes)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputQRCodes, importQRCodes])

  return (
    <>
      <CustomTitleLabel title="Input QR codes" />
      <label className="tips-message">Separate the QR codes by comma.</label>
      <textarea
        onChange={({ target }) => {
          const currentQRcodes = target.value.trim().split(camma);
          setInputQRCodes(currentQRcodes)
        }}
        className="custom-textarea-input-box custom-textarea-input-font"
        onFocus={() => { }}
        value={inputQRCodes?.join(camma)}
      />
      <ReactHookFormErrorMessage errors={errors} id={qrCodeFieldName} />

      <CustomTitleLabel title="Import QR codes" />
      <label className="tips-message">
        Upload a CSV file contains QR codes.
      </label>
      <CSVReader
        ref={buttonRef}
        onFileLoad={handleOnFileLoad}
        onError={handleOnError}
        noClick
        noDrag
        onRemoveFile={handleOnRemoveFile}
      >
        {({ file }) => (
          <div>
            <div style={{ display: showFileBox ? 'flex' : 'none' }}>
              <div className="custom-file-box">{file && file.name}</div>
              <Button
                className="custom-image-button"
                onClick={handleRemoveFile}
              >
                <Image src={deleteImage} />
              </Button>
            </div>

            <Button
              className="multiple-select-option-add btn-add-button-common upload-file-button"
              onClick={handleOpenDialog}
            >
              Choose file
            </Button>
          </div>
        )}
      </CSVReader>
      <ReactHookFormErrorMessage errors={errors} id={qrCodeFieldName} />

      <CustomTitleLabel title="QR codes" />
      <div>
        {qrCodes?.map((element) => {
          return (
            <div className="qr-codes-delete-button">
              <label className="custom-textarea-input-font qr-codes-name-label">
                {element}
              </label>
              <Button
                className="custom-image-button"
                onClick={() => {
                  setInputQRCodes(removeElementFromArray(inputQRCodes, element))
                  setImportQRCodes(removeElementFromArray(importQRCodes, element))
                }}
              >
                <Image src={deleteImage} />
              </Button>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default connect(mapPropsToState)(QRCodeScanningSection);
